function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)
    // 走马灯
    new Swiper('.mySwiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 17,
      slidesPerView: 3,
      freeMode: true,
      speed: 7000, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })

       let prods = window.product
    console.log(prods,'prods')
        function getCur(){
        let size = $('#Size div.active').attr('data-val')
             let color = $('#color div.active').attr('data-val')
          return prods.filter(item=> item.option1 == size && item.option2 == color)[0]
        }
        function changePrice(){
          let num = $('#calcNumber').val()
          console.log(getCur(),'getCur()')
          let price = (getCur().price * num / 100).toFixed(2)
          let compare = (getCur().compare_at_price * num / 100).toFixed(2)
          $('#new').html(price)
          $('#old').html(compare)
           let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".product-part .price3").html(off_font + '% OFF'); 
        }

      $('.sp-btn-style').click(function(){
          let num = $('#calcNumber').val()
          window.location.href = '/cart/' + getCur().id + ':' + num
        })
    //加减
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
      // var number = Number($('#calcNumber').val())
      // $('#new').html((number * Number(9.99)).toFixed(2))
      // $('#old').html((number * Number(15.99)).toFixed(2))
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })

    // style选项
    let typeOptions = $('#color .option')

    // 切换选项
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-0.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-5.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-6.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-7.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-9.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-8.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-10.png',
      'https://cdn.shopify.com/s/files/1/0613/8141/0904/files/20240924-pro-11.png',
    ]
    typeOptions.click(function () {
      let index = $(this).index()
      let index2 = $('#Size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      chageimgs(index2, index)
      changePrice()
    })
    $('#Size .option').click(function () {
      let index = $(this).index()
      let index2 = $('#color .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      chageimgs(index, index2)
      changePrice()
    })
    function chageimgs(index, index2) {
      if (index2 == 0) {
        $('.top-product>img').attr('src', imgArr[index])
      } else if (index2 == 1) {
        $('.top-product>img').attr('src', imgArr[index + 4])
      } else if (index2 == 2) {
        $('.top-product>img').attr('src', imgArr[index + 4 * 2])
      }
    }
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        // var number =
        //   Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        // $('.sp-cart #cardNum').html(number)
        // if (number >= 1) {
        //   $('.sp-cart .num').css('background', '#D6001A')
        // } else {
        //   $('.sp-cart .num').css('background', '#B4B4B4')
        // }


                // 加购
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        };
        
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
            });
          },
          dataType: "json",
        });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: '946px',
          height: '580px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 184,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop 
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
